import { render } from "./Refresh.vue?vue&type=template&id=1ff6d3eb"
import script from "./Refresh.vue?vue&type=script&lang=js"
export * from "./Refresh.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/login/Refresh.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1ff6d3eb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1ff6d3eb', __exports__)) {
    api.reload('1ff6d3eb', __exports__)
  }
  
  module.hot.accept("./Refresh.vue?vue&type=template&id=1ff6d3eb", () => {
    api.rerender('1ff6d3eb', render)
  })

}


export default __exports__